<!-- 组件说明 -->
<!-- 列表的主页 -->
<template>
    <div>
        <van-search 
            v-model="searchValue" 
            :placeholder="$t('index.placeholder')"
            @search="onSearch"
            @cancel="onCancel"
        />
        <!-- 
        <language></language>
        <van-tree-select
          height="145vw"
          :items="items"
          :main-active-index.sync="active"
          @click-nav="getGoodsList"
          >
          <template #content> -->
              <van-row type="flex" gutter="10" style="flex-wrap: wrap; margin:0.5rem 0.24rem">
                  <van-col span="12" v-for="(item,index) in goodsList" :key="index">
                  <div class="item_padding">
                    <router-link :to="'/CategoryDetail/' + item.country +'_'+ item.prodId">
                    <div :class="['goods_item']">
                      <!-- <div :class="['goods_item']" @click="goDetail(item.prodId,item.country,item.combo,item.categoryId)"> -->
                      <van-image :src="item.pic||item.comboPic" class="goods_img" lazy-load />
                      <div class="content">
                        <div class="goods_name">{{item.prodName||item.title}}</div>
                        <div class="goods_menu">
                          <div class="price">
                            <span>{{$t('Pay.money')}}{{item.price}}</span>
                          </div>
                          <!-- <div class="add_cart" @click="addCart(item)">
                            <van-icon name="cart-o" />
                          </div>-->
                        </div>
                      </div>
                    </div>
                    </router-link>
                  </div>
                </van-col>
                <!-- <div class="buy_btn_f">
                  <van-goods-action-icon icon="cart-o" :info="count ==0?'':count" />
                </div> -->
              </van-row>
              <van-pagination 
                v-model="currentPage" 
                :page-count="allPageCount"
                mode="simple" 
                @change="changePage()"
              />
           
          <!-- </template>
      </van-tree-select> -->

    <!-- <van-tabbar  v-model="tabbarActive" active-color="#ee0a24">
          <van-tabbar-item icon="wap-home" @click="toHome()">{{$t('index.index')}}</van-tabbar-item>
          <van-tabbar-item icon="goods-collect">{{$t('index.list')}}</van-tabbar-item>
    </van-tabbar> -->
        <div class="sites">
        <span v-for="(item,index) in siteList" :key="index" @click="toDetail(item.id,item.region)">
          {{item.title}}
          <span v-show="index<(siteList.length-1)" >|</span>
        </span>
      </div>


    </div>
    
</template>

<script>
import { TreeSelect,Grid, GridItem,Lazyload,Search,Pagination, Locale } from 'vant';
import goods from '@/api/goods';
import home from '@/api/home';
import language from './index/common/Language'
import { mapMutations, mapState } from 'vuex';
import { moneys } from "../../static/moneyString"
export default {
  components: { language },
  data() {
    return {
      siteList:[],
      moneysString:'',
      tabbarActive:1, //底部导航
       active: 0,
      //  items: [{text:'新品推薦',type:0},{text:'每日瘋搶',type:1}],
       items: [],
       goodsList:[], //商品列表
       comboList:[],
       searchValue:'', //搜索框中的值
       currentPage: 1, //当前的页数
       allPageCount:1,
       type:'', //当前列表是什么类型的数据
       lang: null,
       shopId:null,
    };
  },
  //  beforeRouteUpdate:(to,from,next)=>{
  //     console.info('传值',this)
  //     this.a.methods.getCategoryInfo(to.query.index)
  //     // this.a.methods.getGoodsList(to.query.index)     
  //     next();
  //   },


  watch: {
    $route: function (to, from) {
        // console.info('---------',to.query.index,from)
        this.getGoodsList(to.query.index)
    },
    regionData: {
      handler(newValue,oldValue){ //当改变时执行事件
       this.onInfo(newValue)
      }
    },
    indexData: {
      handler(newValue,oldValue){ //当改变时执行事件
       this.onInfo(newValue)
      }
    }
  },
  computed: {
    count: {
      get() {
        let cartGoods = this.$store.state.goods.shopCardGoods;
        let count = cartGoods.reduce((total, item) => total + item.num, 0);
        return count;
      },
    },
    regionData: {
      get() {
        return this.$store.state.user.regionData;
      }
    },
    indexData:{
      get() {
        return this.$store.state.user.indexData;
      }
    }
  },
  created(){
  },
  mounted(){
    this.onInfo(0);
    var str=this.$session.get('moneyString');
    this.moneysString=moneys[str];
    let param = this.$route.params || {};
    let host = location.host.split('/')[0]
    if(!sessionStorage.getItem("shopId")){
        setTimeout(()=>{
          location.reload()
        },1000)
      }
    if(this.$route.query.index){
      goods.tagList({id:this.$route.query.index,shopId:sessionStorage.getItem("shopId")}).then((res) => {  //获取产品分类列表
        // console.log('====res=======', res);
        // debugger
        if(res.records.length>0){
          // debugger
          this.goodsList = res.records
        }
        // res.records.forEach(element => {
          
        //   this.items.push({text: element.categoryName,categoryId:element.categoryId})  //产品分类
          
        // });
        // this.getProdTagList(this.$route.query.index)
       
        
      });
    }else{
      home.shopId(host).then((res) => {
        if (res) {
          this.$store.commit('designer/setShopId', res);
          if(param.searchValue){
            this.onSearch(param.searchValue)
            this.searchValue = param.searchValue
          }
          this.getCategoryInfo()
          let shopIds = sessionStorage.getItem("shopId") || this.$store.state.user.regionData.shopId;
          // this.$Fbq.getFbqId('',shopIds)
        }
      })
    }
    
     this.getGoodsList(this.$route.query.index)
  },
  methods: {
    toDetail(id,region) {
      this.$router.push({ name: "siteDetail", params: { id: id,region: region } });
    },
    onInfo(data){
        if(!data){
          goods.topSiteList({ shopId: sessionStorage.getItem('shopId'),region:sessionStorage.getItem('REG') }).then(res => {
            this.siteList = res;
          });
        }else{
          goods.topSiteList({ shopId: data.shopId,region:data.region }).then(res => {
            this.siteList = res;
          });
        }
    },
    toHome(){
       this.$router.replace('/');
    },
    getCategoryInfo(id){ //産品分類信息列表
    
       goods.categoryInfo({shopId:sessionStorage.getItem("shopId")}).then((res) => {  //获取产品分类列表
        // console.log('====res=======', res);
        
        res.forEach(element => {
          
          this.items.push({text: element.categoryName,categoryId:element.categoryId})  //产品分类
          
        });
        this.getProdTagList(id)
       
        
      });
    },
    getProdTagList(){  //商品分组标签列表
      goods.tagProdTagList({shopId:sessionStorage.getItem("shopId")}).then((res) => {
            // console.log('====prodTagList--res=======', res);
             res.forEach(element => {
                this.items.push({text: element.title,id:element.id})  //商品分组分类
              });
          });
       if(!this.searchValue){
          // this.getGoodsList(0)   //默认获取产品分类中第一个分类的商品列表
        }
    },
    goDetail(prodId,country,combo,categoryId) {  //点击进入商品详情页面
    // debugger
    // let prods = country + '_' + prodId
    // let type = this.type
    // // this.$router.push({ name: 'GoodsCategoryDetail', params: {prodId: prods,type:type} });
    // this.$router.push({ name: 'CategoryDetail', params: {prodId: prods,type:type} });
    //   // if(combo){
    //   //   this.$router.push({ name: 'GoodsCategoryDetail', params: { prodId: prodId,type:type} });
    //   // }else{
    //   //    this.$router.push({ name: 'GoodsDetail', params: { prodId: prodId,type:type} });
    //   // }
    },
    getGoodsList(index){   //获取对应产品分类的商品列表
      // let categoryId = this.items[index].categoryId
      let categoryId = index;
      this.currentPage = 1  //将当前的页数还原成1
      this.goodsList= []  // 将列表清空

        // if(categoryId){       //产品分类对应的商品列表
        //       this.getpageProdList(categoryId)
        // }else{   //新品推薦和每日瘋搶
        //     switch(this.items[index].type){
        //       case 0:   //新品推薦
        //         return  this.moreBuyProdList()  
        //       case 1:   //每日瘋搶
        //         return  this.lastedProdPage()
        //       // case 2:   //優惠套餐
        //       //   return  this.getComboList()
        //     }
        // }
        // if(categoryId){    
            this.getpageProdList(categoryId) //产品分类对应的商品列表
        // }else{
        //     this.getTagProdInfo(this.items[index].id)  //商品分组标签列表
        // }
        
    },
    onSearch(val) {
      this.currentPage = 1  //当前页数为1
      this.active = -1  //左侧列表为-1
      this.searchValue = val
      this.getsearchProdPage(val)
    },
    onCancel() {

    },
    getTagProdInfo(id){    //根据商品分组标签列表的id搜索商品列表
     this.type = 'tag';
      goods.tagList({shopId:sessionStorage.getItem("shopId"),id:id,current:this.currentPage}).then((res) => {
            // console.log('====res=======', res);
            this.goodsList = res.records;
            this.pageCount(res)
          });
    },
    getsearchProdPage(prodName){    //根据产品名字搜索商品列表
    // console.log('============fbq-search=======',fbq)
    this.type = 'category';
    fbq('track', 'Search');
      goods.searchProdPage({shopId:sessionStorage.getItem("shopId"), prodName: prodName,current:this.currentPage}).then((res) => {
            // console.log('====res=======', res);
            this.goodsList = res.records;
            this.pageCount(res)
          });
    },
    getpageProdList(categoryId){   //根据産品分類id，获取商品列表
      this.type = 'category';
      goods.pageProd({categoryId:categoryId,current:this.currentPage,shopId:sessionStorage.getItem("shopId")}).then((res) => {
        // debugger
            // console.log('====res=======', res);3
            if(res.records.length>0){
              // debugger
            this.goodsList = res.records
          }
            // this.goodsList = res.records;
            // console.log('this.goodsList',this.goodsList)
            this.pageCount(res)
          });
    },
    moreBuyProdList(){  //新品推薦
        goods.moreBuyProdList({shopId:sessionStorage.getItem("shopId"),current:this.currentPage}).then((res) => {
          // console.log('====res=======', res);
          this.goodsList = res.records;
          this.pageCount(res)
        });
    },
     lastedProdPage(){  //每日瘋搶
        goods.lastedProdPage({shopId:sessionStorage.getItem("shopId"),current:this.currentPage}).then((res) => {
          // console.log('====res=======', res);
          this.goodsList = res.records;
          this.pageCount(res)
        });
    },
    getComboList(){  //套餐优惠
      goods.comboList({shopId:sessionStorage.getItem("shopId"),current:this.currentPage}).then((res) => {
        // console.log('====res=======', res);
        this.goodsList = res.records;
        this.pageCount(res)
      });
    },
    pageCount(res){  //显示总页数和页数
      this.currentPage=res.current, //当前的页数
      this.allPageCount=res.pages  //总页数
      // this.allPageCount=10  //总页数
    },
    changePage(){
      this.getpageProdList( this.$route.query.index) //产品分类对应的商品列表
      // let categoryId = this.items[this.active].categoryId;
      // if(categoryId){    
      //     this.getpageProdList(categoryId) //产品分类对应的商品列表
      // }else{
      //     this.getTagProdInfo(this.items[this.active].id)  //商品分组标签列表
      // }

      // switch(this.active){
      //     case 0:   //新品推薦
      //       return  this.moreBuyProdList()  
      //     case 1:   //每日瘋搶
      //       return  this.lastedProdPage()
      //     case 2:   //優惠套餐
      //       return  this.getComboList()
      //   }
    }
  },
  created() {
    //生命周期 - 创建完成
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped='scoped'>
.title{
    width: 87%;
    height: 1.3rem;
    line-height: 1.3rem;
    background: #b13240;
    color: #fff;
    padding-left: 0.5rem;
    margin: 4%;
    overflow: hidden;
}
.item_padding {
  padding: 0.1rem 0;
}
.goods_item {
  align-items: flex-start;
  position: relative;
  overflow: hidden;
  border-radius: 0.12rem;
  border: 0.04rem #ededed solid;
  height: auto;
  .goods_img {
    width: 100%;
    height: 3rem;
    display: block;

    background: pink;
  }
  .content {
    padding: 0.32rem;
    .goods_name {
      margin-bottom: 0.32rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
      color: #333;
    }
    .goods_menu {
      display: flex;
      align-items: center;
      .price {
        flex: 1;
      }
      .add_cart {
        background: #fff;
        padding: 0.15rem;
        border: 0.04rem #ddd solid;
        border-radius: 100%;
      }
    }
  }
}
</style>
<style lang='scss'>
.buy_btn_f {
  position: fixed;
  bottom: 2rem;
  left: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  .van-goods-action-icon {
    // background:  #ce4b5a;
      background: rgba($color: #a31e2d, $alpha: 0.4);
    border-radius: 100%;
    .van-goods-action-icon__icon {
      margin: 0 auto;
      font-size: 1rem;
      color: #fff;
    }
  }
}
.goods_item{
  // height: 320px;
}
.van-image__img{
  // height: 150px;
}
.content{
  margin-top: 20px;
}
.site {
  margin: 30px 0;
  text-align: center;
  padding: 0 30px;
  font-size: 14px;
}
.site span{
  padding: 2px 0;
  display: block;
}
.sites {
  margin: 30px 0;
  text-align: center;
  padding: 0 30px;
  font-size: 12px;
  // font-family: 'Medium';
  display: block;
  // font-family: 'Bold';
}
.sites span {
  padding: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/GoodsCategory.vue